import ApiService from './../api/ApiService';
import Urls from './../api/Urls';
import Config from "./../constants/Config"
import { COUNTRY_CODE } from "./../constants/Define"
import Province, { provinces } from './../models/Province';
import ExchangeRate from './../models/ExchangeRate';
import { FlightConfig } from './../models/Flight';
import {vietnameseStringToUnicode} from '../helpers/functions';
import { orderBy } from 'lodash';

export function getProvinces(countryCode = COUNTRY_CODE.VN) {
    return new ApiService({
        baseURL: Config.API_TOUR,
        endpoint: Urls.PROVINCE_LIST,
        params: { country: countryCode },
        parser: (data) => orderBy((data.data || []).map(item => new Province(item)), [(item) => vietnameseStringToUnicode(item.name.toLowerCase())], ['asc']),
    }).get();
}

export function getGooglePlacesDetail(place_id, key) {
    return new ApiService({
        baseURL: Urls.GOOGLE_MAPS_API,
        endpoint: Urls.PLACE_DETAIL,
        withoutAuth: true,
        params: { place_id, key },
    }).get();
}

export function getFlightConfig(){
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FLIGHT_CONFIG,
        parser: data => new FlightConfig(data.data),
    }).get();
}

export function updateFlightConfig(flightConfig){
    return new ApiService({
        baseURL: Config.API_FLIGHT,
        endpoint: Urls.FLIGHT_CONFIG,
        parser: data => new FlightConfig(flightConfig.export()),
    }).put(flightConfig.export());
}


export function getExchangeRates() {
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_EXCHANGE_RATE_LIST,
        parser: (data) => (data.data || []).map(item => new ExchangeRate(item)),
    }).get();
}

export function updateExchangeRate(exchangeRate){
    return new ApiService({
        baseURL: Config.API_VOUCHER,
        endpoint: Urls.VOUCHER_EXCHANGE_RATE_UPDATE,
    }).post(exchangeRate.export());
}
